// The items of an indexed list take their position in it: a removal leaves no hole a later
// addition, indexed by the length of the list, would collide with.
export const renumber = <Item extends Readonly<{ index: number }>>(
  items: readonly Item[],
): Item[] => items.map((item, index) => ({ ...item, index }));
